// 计算api接口的基本地址
let hostname = location.hostname;
hostname = hostname.substring(hostname.indexOf('.'));
let appHost = `${location.protocol}//api${hostname}`;
const baseUrl = `${appHost}/zmtx/`;
import axios from 'axios'

//公益专员登陆
export function volunteerLogin(data) {
    return axios.post(`${baseUrl}volunteer/login`, data)
}
//获取公益专员信息
export function getVolunteerInfo(data) {
    return axios.post(`${baseUrl}pap/getVolunteerInfo`, data)
}
//患者管理-获取公益专员底下的患者
export function getPatientStatusList(data) {
    return axios.post(`${baseUrl}pap/getPatientStatusList?`, data)
}
//患者管理-按阶段查询进度的数据源
export function getApplys(data) {
    return axios.post(`${baseUrl}pap/getApplys`, data)
}
//患者管理-按阶段查询进度的数据源- 点击患者的阶段日志
export function newApplysGoingByPhaseDesc(data) {
    return axios.post(`${baseUrl}pap/newApplysGoingByPhaseDesc`, data)
}
//消息推送-患者服务列表
export function getPatientServiceList(data) {
    return axios.post(`${baseUrl}pap/getPatientServiceList`, data)
}
//消息推送-标记为已读
export function sendQaStatus(data) {
    return axios.post(`${baseUrl}pap/sendQaStatus`, data)
}
//消息推送-创建或跟新患者服务
export function savePatientService(data) {
    return axios.post(`${baseUrl}pap/savePatientService`, data)
}
// //患者服务-患者服务列表
// export function getPatientServiceList(data) {
//     return axios.post(`${baseUrl}pap/getPatientServiceList`, data)
// }
//患者服务-公益专员可选的省市
export function getVolunteerProvinceCity(data) {
    return axios.post(`${baseUrl}pap/getVolunteerProvinceCity`, data)
}
//患者服务-获取患者服务服务项-下拉数据
export function getPatientServiceOptions(data) {
    return axios.post(`${baseUrl}pap/getPatientServiceOptions`, data)
}
//患者服务-获取患者服务咨询方式-下拉数据
export function getConsultServiceOptions(data) {
    return axios.post(`${baseUrl}pap/getConsultServiceOptions`, data)
}
//医护拜访-列表
export function getDoctorVistList(data) {
    return axios.post(`${baseUrl}pap/getDoctorVistList`, data)
}
//医护拜访-详情
export function getDoctorVist(data) {
    return axios.post(`${baseUrl}pap/getDoctorVist`, data)
}
//医护拜访-创建
export function createDoctorVist(data) {
    return axios.post(`${baseUrl}pap/createDoctorVist`, data)
}
// //医护拜访-拜访方式选择项
// export function getConsultServiceOptions(data) {
//     return axios.post(`${baseUrl}pap/getConsultServiceOptions`, data)
// }
//医护拜访-目标选择项
export function getVisitTaskOptions(data) {
    return axios.post(`${baseUrl}pap/getVisitTaskOptions`, data)
}
//监督发药-列表
export function getDrugDispenseList(data) {
    return axios.post(`${baseUrl}pap/getDrugDispenseList`, data)
}
//监督发药-详情
export function getDrugDispense(data) {
    return axios.post(`${baseUrl}pap/getDrugDispense`, data)
}
//监督发药-创建
export function createDrugDispense(data) {
    return axios.post(`${baseUrl}pap/createDrugDispense`, data)
}
//监督发药-获取药房底下患者的预测单
export function getDrugstorePredictAll(data) {
    return axios.post(`${baseUrl}pap/getDrugstorePredictAll`, data)
}
//盘点库存-详情
export function getDrugstoreTake(data) {
    return axios.post(`${baseUrl}pap/getDrugstoreTake`, data)
}
//盘点库存-列表
export function getDrugstoreTakeList(data) {
    return axios.post(`${baseUrl}pap/getDrugstoreTakeList`, data)
}
//盘点库存-创建
export function createDrugstoreTake(data) {
    return axios.post(`${baseUrl}pap/createDrugstoreTake`, data)
}
//盘点库存-获取药品
export function getDrug(data) {
    return axios.post(`${baseUrl}pap/getDrug`, data)
}
//盘点库存-获取药品库存批号
export function getDrugstoreStock(data) {
    return axios.post(`${baseUrl}pap/getDrugstoreStock`, data)
}
//用药回访-列表
export function getPatientVistList(data) {
    return axios.post(`${baseUrl}pap/getPatientVistList`, data)
}
//用药回访-详情
export function getPatientVist(data) {
    return axios.post(`${baseUrl}pap/getPatientVist`, data)
}
//用药回访-创建
export function createPatientVist(data) {
    return axios.post(`${baseUrl}pap/createPatientVist`, data)
}
//用药回访-获取未用药原因
export function getPatientVistOptions(data) {
    return axios.post(`${baseUrl}pap/getPatientVistOptions`, data)
}
//服务记录
export function getVolunteerServiceRecords(data) {
    return axios.post(`${baseUrl}pap/getVolunteerServiceRecords`, data)
}
//服务记录-患者列表
export function getAssistanceLog(data) {
    return axios.post(`${baseUrl}pap/getAssistanceLog`, data)
}



//获取患者id和papid
export function hasPatient(data) {
    return axios.post(`${baseUrl}patient/has-patient`, data)
}



//获取患者id和papid
export function Logout(data) {
    return axios.post(`${baseUrl}volunteer/logout`, data)
}